import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { ScrollTable } from './ScrollTable';
import { moduleComparison, moduleIncludes } from '../data/content';
export function ModuleSection() {
  return <section className="w-full bg-surface px-5 py-16 sm:px-8 sm:py-24" aria-labelledby="modulo-title" data-id="element-158" data-mp="16bxs7044ao77">
      <div className="mx-auto max-w-5xl" data-id="element-159" data-mp="wk0hrvkxo09j">
        <SectionHeading eyebrow="🏋️ Programación personalizada" title="¿Qué agrega el módulo de programación personalizada?" data-id="element-160" data-mp="wj8jgczybofk" />

        <div className="mt-10" data-id="element-161" data-mp="njbz2nklhbqb">
          <ScrollTable data-id="element-162" data-mp="nkdet5ck2med">
            <table className="w-full min-w-[640px] border-collapse text-left" data-id="element-163" data-mp="nkwu0eatmwop">
              <caption className="sr-only" data-id="element-164" data-mp="rlqknffnepla">
                Comparación entre entrenar sin el módulo y con el módulo de
                programación personalizada
              </caption>
              <thead data-id="element-165" data-mp="ikipv7ccc6vy">
                <tr className="bg-ink" data-id="element-166" data-mp="ijppco3z6dm9">
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-neutral-300" data-id="element-167" data-mp="3091qe03qwkz7">
                    Situación en el entrenamiento
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-ember" data-id="element-168" data-mp="398geiswfwjgj">
                    ❌ Sin módulo
                  </th>
                  <th scope="col" className="px-5 py-4 text-xs font-extrabold uppercase tracking-wider text-gold" data-id="element-169" data-mp="2giq16m2mtllh">
                    ✅ Con módulo
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-170" data-mp="2lim6qpqz9l35">
                {moduleComparison.map(row => <tr key={row.situation} className="border-t border-line" data-id="element-171" data-mp="1xtt8unqsp35w">
                    <th scope="row" className="px-5 py-4 text-sm font-semibold text-white" data-id="element-172" data-mp="1svrl3pifcfo3">
                      {row.situation}
                    </th>
                    <td className="px-5 py-4 text-sm text-neutral-500" data-id="element-173" data-mp="1qof31g7qasp">
                      {row.without}
                    </td>
                    <td className="px-5 py-4 text-sm font-medium text-neutral-200" data-id="element-174" data-mp="6iyd74rheh62">
                      {row.with}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </ScrollTable>
        </div>

        <div id="modulo-title" className="mt-10 rounded-3xl border border-gold/25 bg-ink p-6 sm:p-8" data-id="element-175" data-mp="3ex6ngwq4yl9f">
          <h3 className="text-lg font-extrabold tracking-tight text-gold" data-id="element-176" data-mp="3jvhyhas631t8">
            ✅ El módulo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 md:grid-cols-2" data-id="element-177" data-mp="3nwk1m2p7fy0h">
            {moduleIncludes.map(item => <li key={item} className="flex items-start gap-3" data-id="element-178" data-mp="z96l83sazl6x">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-179" data-mp="136ukfj11404m" />
                <span className="text-sm text-neutral-300" data-id="element-180" data-mp="2jov1ia1urjwq">{item}</span>
              </li>)}
          </ul>
        </div>

        <p className="mt-6 flex items-start gap-2 text-xs text-neutral-600" data-id="element-181" data-mp="2ex4izgsrhpu8">
          <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0" aria-hidden="true" data-id="element-182" data-mp="29zl6albppl4e" />
          Sin el módulo seguís teniendo los 6 tomos y los 6 bonos completos.
        </p>
      </div>
    </section>;
}